import { render, staticRenderFns } from "./PronosticoAire.vue?vue&type=template&id=0d27abe8&scoped=true"
import script from "./PronosticoAire.vue?vue&type=script&lang=ts"
export * from "./PronosticoAire.vue?vue&type=script&lang=ts"
import style0 from "./PronosticoAire.vue?vue&type=style&index=0&id=0d27abe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d27abe8",
  null
  
)

export default component.exports